export enum TipoCampoAdicional {
	Texto = 'VARCHAR',
	Booleano = 'BIT',
	Numerico = 'BIGINT',
	Fecha = 'DATETIME',
	TextArea = 'TEXT_AREA',
	Multiple = 'MULTIPLE',
	MultipleCaracteristica = 'MULTIPLE_CARACTERISTICAS',
	VariosRegistros = 'VARIOS_REGISTROS',
	TipoDocumento = 'DROPDOWNTID',
	Municipio = 'DROPDOWNMUN'
}
